module.exports = __webpack_public_path__ + "media/svg/GraphUp-ed5b1a5e.svg";